import { atomWithStorage, createJSONStorage } from "jotai/utils"
import { z } from "zod"

export type MileageFormData = {
	inputMethod: "odometer" | "total"
	startOdometer: string
	endOdometer: string
	totalMiles: string
}

export const mileageSchema = z.object({
	inputMethod: z.union([z.literal("odometer"), z.literal("total")]),
	startOdometer: z.string(),
	endOdometer: z.string(),
	totalMiles: z.string(),
})

const storage = createJSONStorage<MileageFormData>(() => localStorage)

export const defaultMileage: MileageFormData = {
	inputMethod: "odometer",
	startOdometer: "0",
	endOdometer: "0",
	totalMiles: "0",
}
export const mileageDraftAtom = atomWithStorage<MileageFormData>(
	"miles:draft:mileage",
	defaultMileage,
	storage,
	{ getOnInit: true }
)
